import { getToken } from "../cookie/authCookie";
import  axiosInstance  from "./config/axiosConfigs";

export const AccountSetupAPI = {

  getAllSteps: async function (clubId, userId) {
  
    const response = await axiosInstance.request({
      url: `/account/setup/club/${clubId}/user/${userId}`,
      method: "GET",
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAccountSetupCompletedDetails: async function (clubId) {
  
    const response = await axiosInstance.request({
      url: `/account/is-completed/${clubId}`,
      method: "GET",
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAccountSetupIaCustomerPayFee: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/account/is-customer-pay-fee/club/${clubId}`,
      method: "GET",
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postStepper: async function (stepperDetails) {
    const response = await axiosInstance.request({
      url: `/account/setup/steps`,
      method: "POST",
      timeout: 5000,
      data: stepperDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  updateRegistrationFeeDetails: async function (clubInfo) {
    const response = await axiosInstance.request({
      url: `/account/update-registration-fee/user/${clubInfo.userId}/club/${clubInfo.clubId}`,
      method: "POST",
      data: { clubChargeAmount: clubInfo.clubChargeAmount },
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },

  updateIsPlanRequired: async function (accountSetupInfo) {
    const response = await axiosInstance.request({
      url: `/account/setup/type`,
      method: "PUT",
      data: accountSetupInfo,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },

  updateIsCustomerPayFee: async function (data) {
    const response = await axiosInstance.request({
      url: `/account/is-customer-pay-fee`,
      method: "PUT",
      data: data,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },

  getRegistrationFeeDetails: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/account/get-registration-fee/club/${clubId}`,
      method: "GET",
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },
  };